// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jfJt","left":"styles_left__2I1KN"};